export default function saveFile({ href, name }: { href: string; name: string }) {
  const link = document.createElement("a");
  link.href = href;
  link.download = name;
  link.setAttribute("target", "_blank");
  link.click();
  link.remove();
}
